/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import holeManager from 'scripts/services/hole-manager';
import template from './sudden-death.stache';

Component.extend({
    tag: 'leaderboard-sudden-death',
    leakScope: false,
    template: template,
    viewModel: {
        emptyHolesCache: [],
        sponsor: null,
        define: {
            extraPlayoff: {
                Type: can.Map,
            },
            roundHoleResults: {
                Type: can.Map,
                get() {
                    const players = this.attr('extraPlayoff.players');
                    const playedHoles = Math.max(
                        ...players.map((player) =>
                            player.attr('scorecard.holeResults.length'),
                        ),
                    );
                    return players
                        .filter(
                            (player) =>
                                player.attr('scorecard.holeResults.length') ===
                                playedHoles,
                        )
                        .pop()
                        .attr('scorecard.holeResults');
                },
            },
            emptyHoles: {
                Type: can.Map,
                get() {
                    const players = this.attr('extraPlayoff.players');
                    const playedHoles = Math.max(
                        ...players.map((player) =>
                            player.attr('scorecard.holeResults.length'),
                        ),
                    );
                    const emptyHoles = new Array(Math.max(0, 9 - playedHoles));
                    const previousEmptyHoles = this.attr('emptyHolesCache');
                    if (previousEmptyHoles.length === emptyHoles.length) {
                        return previousEmptyHoles;
                    } else {
                        this.attr('emptyHolesCache', emptyHoles);
                        return emptyHoles;
                    }
                },
            },
        },

        getPlayerEmptyHoles(player) {
            const playedHoles = player.attr('scorecard.holeResults.length');
            return new Array(Math.max(0, 9 - playedHoles));
        },

        getScoreColor(score, par) {
            return holeManager.getScoreName(score, par);
        },

        getScoreValue(score) {
            if (!score) {
                return '--';
            }

            return score;
        },
    },
    events: {
        inserted(element) {
            setTimeout(() => {
                element
                    .find('.c-leaderboard-sudden-death')
                    .addClass('c-leaderboard-sudden-death--animate');
            }, 0);
        },
    },
});
